import {Provider} from '@angular/core';

import {MyCustomerDataUseCase} from '@features/customer/application/use_cases/my-customer-data/my-customer-data.use-case';

import {
  MyCustomerDataHttpProvider
} from '@features/customer/infrastructure/http/my-customer-data/my-customer-data.http.provider';

export const MyCustomerDataUseCaseProvider: Provider[] = [
  ...MyCustomerDataHttpProvider,
  MyCustomerDataUseCase
];
